export default __webpack_public_path__ + "static/media/lpm.a6195d26.webp";